import { isDOMElement } from'./context.mjs';
import { createDOMElement } from'./create.mjs';
import { flatten } from'../common/util.mjs';
import { createUJSXObject, isUJSXObject } from'../common/object.mjs';
const ELEMENT_NODE = 1;
const TEXT_NODE = 3;
const DOCUMENT_NODE = 9;
const DOCUMENT_FRAGMENT_NODE = 10;
export function ujsxObjectToDOM(ctx, obj) {
    return createDOMElement(ctx, obj.tag, obj.attributes, obj.children);
}
export function ujsxToDOM(ctx, ujsx) {
    const document = ctx.document;
    if (typeof ujsx != 'object')
        return document.createTextNode(String(ujsx));
    if (Array.isArray(ujsx))
        return flatten(ujsx).map(e => ujsxToDOM(ctx, e));
    if (isDOMElement(ctx, ujsx))
        return ujsx;
    if (!isUJSXObject(ujsx))
        return document.createTextNode(String(ujsx));
    return ujsxObjectToDOM(ctx, ujsx);
}
export function domToUJSX(node) {
    const nt = node && node.nodeType;
    const recc = () => Array.from(node.childNodes).map(cn => domToUJSX(cn));
    if (!nt || nt == TEXT_NODE)
        return node && node.textContent;
    if (nt == DOCUMENT_NODE || nt == DOCUMENT_FRAGMENT_NODE)
        return recc();
    if (nt != ELEMENT_NODE)
        return null;
    const el = node;
    const attrs = {};
    for (let attr of Array.from(el.attributes)) {
        attrs[attr.name] = attr.value;
    }
    return createUJSXObject(el.tagName, attrs, recc());
}
//# sourceMappingURL=convert.mjs.map